import script from "./user-header.vue?vue&type=script&setup=true&lang=js"
export * from "./user-header.vue?vue&type=script&setup=true&lang=js"

import "./user-header.vue?vue&type=style&index=0&id=49fd3c8a&lang=css"

const __exports__ = script;

export default __exports__